import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LucideAngularModule, ThumbsUp } from 'lucide-angular';

@Component({
  selector: 'app-recommendation',
  imports: [LucideAngularModule],
  templateUrl: './recommendation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationComponent {
  readonly recommendation = input.required<string>();
  readonly thumbsUp = ThumbsUp;
}
